export default __webpack_public_path__ + "static/sample-a770a6651ec964b83bfc3118c804fb60.jpg";